import { useCancelProcess } from "@/hooks/use-cancel-process";
import { useTextToMusicProgressContext } from "@/components/pages/text-to-music/components/providers/text-to-music-progress-provider";

export const useCancelTextToMusic = () => {
  const progressContext = useTextToMusicProgressContext();

  const { cancelProcess, isLoading } = useCancelProcess(
    "/api/text-to-music/cancel?",
    new URLSearchParams({
      text_to_music_id: progressContext.processId!,
    }),
    () => progressContext.forceCancelCurrentProcess(),
  );

  return { cancelTextToMusic: cancelProcess, isCancelling: isLoading };
};
